import { Injectable, LOCALE_ID, Inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IntlService, CldrIntlService, DateFormatNameOptions, DateFieldNameOptions } from '@progress/kendo-angular-intl';

@Injectable()
export class KendoCultureService extends CldrIntlService {
  constructor(@Inject(LOCALE_ID) localeId: string, private translate: TranslateService) {
    super(localeId);
  }

  public override dateFormatNames(options: DateFormatNameOptions, localeId?: string): string[] {
    const currentLocaleId = localeId || this.localeId;

    if (currentLocaleId === 'en') {

      if (options.type === 'months' && options.nameType === 'wide') {
        const keys = [
          '_General_January_Text_', '_General_February_Text_', '_General_March_Text_',
          '_General_April_Text_', '_General_May_Text_', '_General_June_Text_',
          '_General_July_Text_', '_General_August_Text_', '_General_September_Text_',
          '_General_October_Text_', '_General_November_Text_', '_General_December_Text_'
        ];
        return keys.map(key => this.translate.instant(key));
      }
      if (options.type === 'months' && options.nameType === 'abbreviated') {
        const keys = [
          '_General_January_Abbreviated_Text_', '_General_February_Abbreviated_Text_', '_General_March_Abbreviated_Text_',
          '_General_April_Abbreviated_Text_', '_General_May_Abbreviated_Text_', '_General_June_Abbreviated_Text_',
          '_General_July_Abbreviated_Text_', '_General_August_Abbreviated_Text_', '_General_September_Abbreviated_Text_',
          '_General_October_Abbreviated_Text_', '_General_November_Abbreviated_Text_', '_General_December_Abbreviated_Text_'
        ];
        return keys.map(key => this.translate.instant(key));
        //AM/PM value changes are not supported right now , If it does in future , add it here .
      }

      
      
    }

    // Fallback to default Kendo UI (CLDR) behavior for other locales or options
    return super.dateFormatNames(options, localeId);
  }
    override dateFieldName(options: DateFieldNameOptions, localeId?: string): string {

      if (options.type === 'hour') {
        return this.translate.instant('_General_Hour_Text_');
      }
      if (options.type === 'minute') {
        return this.translate.instant('_General_Minute_Text_');
      }
      if (options.type === 'second') {
        return this.translate.instant('_General_Second_Text_');
      }
      // Currently the dayperiod values are not supported . Headers are supported but due to the inconsistency , commented it out .
      // if (options.type === 'dayperiod') {
      //   return this.translate.instant('_General_Dayperiod_header_Text_');
      // }

      // Fallback to default behavior
      return super.dateFieldName(options, localeId);
    }
}
